import * as registrationApis from "../../../../network/apis/companyPortalRegistration";

export const OTP_LENGTH = 4;

export const digitsOnly = (str) => String(str || "").replace(/\D/g, "");

/**
 * @param {string} pasted
 * @returns {string} up to OTP_LENGTH numeric digits
 */
export const digitsFromPaste = (pasted) =>
  digitsOnly(pasted).slice(0, OTP_LENGTH);

/**
 * @param {number} totalSeconds non-negative
 * @returns {string} MM:SS
 */
export const formatCountdownMmSs = (totalSeconds) => {
  const safe = Math.max(0, Math.floor(totalSeconds));
  const m = Math.floor(safe / 60);
  const s = safe % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
};

export const isCompleteOtp = (otp) =>
  Boolean(otp && otp.length === OTP_LENGTH && /^\d{4}$/.test(otp));

/**
 * @param {string} otp — 4-digit code
 * @returns {Promise<object>} API data (merged into session by caller)
 */
export async function verifyRegistrationOtp(otp) {
  return registrationApis.verifyCompanyUserEmail({
    email_verification_code: otp,
  });
}

/**
 * @returns {Promise<object>} Updated user payload (incl. can_resend_activation_code when present)
 */
export async function resendRegistrationOtp() {
  return registrationApis.resendCompanyUserEmailVerification();
}
